import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/app/AuthProvider';

export function InactivePage() {
  const { signOut, user } = useAuth();
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <Logo variant="symbol" tone="humus" className="mx-auto h-12 w-12" />
        <div className="space-y-2">
          <h1 className="text-2xl font-medium tracking-headline">Account inactive</h1>
          <p className="text-sm text-muted-foreground">
            {user?.email ?? 'Your account'} has been deactivated. Contact a
            Super Admin to restore access.
          </p>
        </div>
        <Button onClick={() => signOut()}>Sign out</Button>
      </div>
    </div>
  );
}
